import React, { useContext, useMemo, useState } from 'react'
import { Button, Col, Row } from 'react-angle-dashboard-components'
import { useHistory } from 'react-router-dom'
import { Question, QuestionContainer, SubText } from '../../components/Question'
import { useCaptureValue } from '../../hooks/use-capture-question'
import useStep from '../../hooks/use-step'
import { GbsStore } from '../../store'
import { useStepData } from '../../store/selectors'
import { Paths } from '../../routes/paths'

const stepKey = 'currentCarrier'

export const CurrentCarrier = () => {
  const { dispatch } = useContext(GbsStore)
  const history = useHistory()
  const stepData = useStepData(stepKey)
  const [value, setValue] = useState<string>(stepData?.value || '')
  const { captureAnswer, isLoading } = useCaptureValue(
    stepKey,
    {
      current_carrier: { medical_carrier: value }
    },
    value
  )

  const onContinue = async () => {
    if (!(await captureAnswer())) return
    history.push(Paths.renewingCoverage)
  }

  const isDisabled = !value || isLoading

  const stepConfig = useMemo(() => {
    return {
      topBar: {
        completedPercentage: 25,
        backCallback: () => history.push(Paths.currentlyMedical)
      },
      bottomBar: {
        hidden: true
      }
    }
  }, [history])

  useStep(stepKey, stepConfig, dispatch)
  return (
    <QuestionContainer>
      <Row>
        <Col xs={12}>
          <Question
            type="text"
            defaultValue={value}
            text="Who is your current insurance provider?"
            placeholder="Insurance Provider"
            onChange={(value) => setValue(value)}
          ></Question>
        </Col>
      </Row>

      <div className="text-center">
        <Button
          style={{ width: 130 }}
          variant="primary"
          onClick={onContinue}
          disabled={isDisabled}
        >
          Next
        </Button>
      </div>
      <SubText>
        All insurance plans are issued by Angle Insurance Company of Utah
      </SubText>
    </QuestionContainer>
  )
}

export default CurrentCarrier
